import React from 'react'
import { Container } from '../../../../../components/Container'
import { ContactSupportButton } from './CustomCards/ContactSupportButton'
import { UserFeedback } from './CustomCards/UserFeedback'
import { VideoCard } from './CustomCards/VideoCard'
import { ChatMessageContent } from '../../types'
import { useTheme } from '@material-ui/core'
import { NavigateCard } from './CustomCards/NavigateCard'
import { ProjectPlanCard } from './CustomCards/ProjectPlanCard'
import { CreateDeadlineCard } from './CustomCards/CreateDeadlineCard'
import { CreateProjectCard } from './CustomCards/CreateProjectCard'
import { TrainingVideoController } from '../../../../../hooks/useTrainingVideo'
import { ProjectPlanController } from '../../../../../hooks/useProjectPlan'
import { CreateInspectionCard } from './CustomCards/CreateInspectionCard'

interface RenderCardsProps {
    function_call: ChatMessageContent
    trainingVideoController: TrainingVideoController
    projectPlanController: ProjectPlanController
}

export const RenderCards: React.FC<RenderCardsProps> = ({
    function_call,
    trainingVideoController,
    projectPlanController,
}) => {
    const theme = useTheme()

    // Type guard to ensure function_call is a valid FunctionCall
    const functionCallType = function_call.function_call

    if (!functionCallType) return null

    switch (functionCallType) {
        case 'create_project':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <CreateProjectCard message={function_call} />
                    <UserFeedback message={function_call} />
                </Container>
            )
        case 'create_deadline':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <CreateDeadlineCard message={function_call} />
                    <UserFeedback message={function_call} />
                </Container>
            )
        case 'create_inspection':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <CreateInspectionCard message={function_call} />
                    <UserFeedback message={function_call} />
                </Container>
            )

        case 'how_to_video_list':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <VideoCard
                        message={function_call}
                        trainingVideoController={trainingVideoController}
                    />
                    {/* <UserFeedback message={function_call} /> */}
                </Container>
            )
        case 'project_plan':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <ProjectPlanCard
                        message={function_call}
                        projectPlanController={projectPlanController}
                    />
                    <UserFeedback message={function_call} />
                </Container>
            )
        case 'navigate_url':
            return (
                <Container style={{ display: 'flex', flexDirection: 'column' }}>
                    <NavigateCard message={function_call} />
                    <UserFeedback message={function_call} />
                </Container>
            )
        case 'contact_support':
            return <ContactSupportButton />

        default:
            return null
    }
}
